import { AgingReport, useGetAgingQuery } from '@/services/agingDashboard';
import { Box, Table } from '@palmetto/palmetto-components';
import classNames from 'classnames';

import { AgingQuery, AgingQueryGroupMap, agingLabels } from 'types';

import styles from './AgingDashboard.module.scss';
import { ISectionToLoad, reportDataToSubsection, SectionsToLoad } from './Helpers';

export const AgingGroupSubsection = ({ query }: { query: AgingQuery }) => {
  const { data: group, error } = useGetAgingQuery(query);

  if (error) {
    return (
      <Box margin={'0 0 lg 0'} color="danger">
        <span>
          Error loading <strong>{agingLabels[query]}</strong> section
        </span>
      </Box>
    );
  }
  const subSection = reportDataToSubsection({
    data:
      group ||
      Object.values(AgingQueryGroupMap[query]).reduce((acc, agingGroup) => {
        acc[agingGroup] = { value: '', accountData: [] };
        return acc;
      }, {} as AgingReport),
    agingGroup: query,
  });

  return (
    <Box margin={'0 0 lg 0'}>
      {
        <Table
          columns={subSection.columns}
          rows={subSection.rows}
          rowKey="count"
          key={subSection.rowKey}
          isScrollable={{
            x: true,
          }}
          isLoading={!group}
          className={classNames(styles.table)}
        />
      }
    </Box>
  );
};

export const AgingGroupSection = ({ section }: { section: ISectionToLoad }) => {
  return (
    <Box>
      <Box fontSize={'lg'} fontWeight={'medium'}>
        {section.title}
      </Box>
      <Box
        style={{
          marginTop: '4px',
          marginBottom: '8px',
        }}
      >
        {section.description}
      </Box>
      {section.agingGroups.map((subsection) => {
        return <AgingGroupSubsection key={`${subsection}${section.title}`} query={subsection} />;
      })}
    </Box>
  );
};

export const AgingDashboard = () => {
  return SectionsToLoad.map((section) => {
    return (
      <Box key={section.title}>
        <AgingGroupSection section={section} />
      </Box>
    );
  });
};
